module.exports = __webpack_public_path__ + "img/1.d6577551.jpg";